// extracted by mini-css-extract-plugin
module.exports = {"header":"FactsHeader_header__OgnMj","meta":"FactsHeader_meta__Ewo5H","metaItem":"FactsHeader_metaItem__34mJQ","reportButton":"FactsHeader_reportButton__3vlDg"};